import http from "./http-common";
import authHeader from "./auth-header";

class AnalyticsService {
    trackEvent(data) {
        return http.post("analytics/track", data, { headers: authHeader() });
    }

    getProductAnalytics(productId) {
        return http.get(`analytics/product/${productId}`, { headers: authHeader() });
    }

    getSellerAnalytics(sellerId) {
        return http.get(`analytics/seller/${sellerId}`, { headers: authHeader() });
    }
}

export default new AnalyticsService();
